import { useModal } from "@lobby/core/src/shared";
import { useTranslate } from "@lobby/ocb-intl";
import { useIsMutating } from "@tanstack/react-query";
import { Modal } from "shared/ui/modal";
import { PasswordResetForm } from "./components";

export function PasswordResetModal({ isStatic = false }: { isStatic?: boolean }) {
  const { isOpen, close } = useModal("password-reset");

  return (
    <Modal open={isOpen}>
      <Modal.Overlay onClick={isStatic ? undefined : close} />
      <PasswordResetModalComponent />
    </Modal>
  );
}

function PasswordResetModalComponent() {
  const { $t } = useTranslate();

  const isPending = useIsMutating({ mutationKey: ["Email.setNewPassword"] }) > 0;

  return (
    <Modal.Panel className="lg:rounded-rounded lg:border-1 lg:top-17 lg:w-[35rem] bg-mercury border-keppel p-5 w-full dark:border-shark dark:bg-ebony-clay">
      <p className="font-bold text-xl uppercase text-center">
        {$t({ defaultMessage: "Reset your password" })}
      </p>
      <p className="text-center">{$t({ defaultMessage: "Enter a new password below" })}</p>

      <div className="mt-5">
        <PasswordResetForm />
      </div>

      <Modal.PendingOverlay isActive={isPending} />
    </Modal.Panel>
  );
}
